// extracted by mini-css-extract-plugin
module.exports = {"HEIGHT":"56px","container":"qia6P","titleRow":"_3x2ZA","left":"_3yW1b","right":"_15uNB","leftPanel":"_14Dzx","rightPanel":"_3F4VW"};